import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Popover, OverlayTrigger, FormControl } from 'react-bootstrap';
import { createPersonalChannel, renamePersonalChannel, deletePersonalChannel } from '../../../../../../actions/Dashboard/personalBoards/channelsActions';
import { showModal } from '../../../../../../actions/modalsActions';

const AddChannel = ({ channel, trigger }) => {
    //redux store state
    const channels = useSelector(state => state.personalBoard.channels)
    const dispatch = useDispatch();
    //comp state
    const [channelName, setChannelName] = useState(channel ? channel.name : '');
    const [error, setError] = useState('');

    useEffect(() => {
        if (channel) setChannelName(channel.name)
    }, [channel])

    const onAddClick = async () => {
        if (!channelName) return setError('Please Add Channel Name')
        if (!channelName.match(/^[a-zA-Z0-9_ ]*$/)) return setError('Only characters and numbers')

        //checking if there is a channel with the same name
        const existChannel = channels.find(el => el.name === channelName)
        if (existChannel) return setError('There is a channel with the same name');

        // reset the error if there is an error after user has corrected the inputs
        if (error) setError('');

        if (channel) {
            dispatch(renamePersonalChannel(channel._id, channelName))
        } else {
            dispatch(createPersonalChannel(channelName))
        }

        //reseting the fields and closing the adding popup
        setChannelName('');
        document.body.click()
    }

    const onDeleteClick = () => {
        dispatch(deletePersonalChannel(channel._id))
        console.log('delete channel clicked');
    }

    const deleteConfirmContent = () => {
        return (
            <div className="d-flex justify-content-center my-3">
                <h3>Are you sure you want to delete channel <span className="text-bold text-red">{channel.name}</span> and all its content?</h3>
            </div>
        )
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Title as="h3" className="d-flex align-content-canter">
                <span>{channel ? 'Edit' : 'Add'} Channel</span>
                <span className="material-icons pointer text-light-grey text-sm ml-auto" onClick={() => document.body.click()}>close</span>
            </Popover.Title>
            <Popover.Content>
                <FormControl value={channelName} placeholder="Channel Name" onChange={(e) => setChannelName(e.target.value)} />
                {error && <p className="text-xs text-red mb-0">{error}</p>}
                <Button className="mt-3 mr-2" variant="primary" onClick={onAddClick}>{channel ? 'Save' : 'Add'}</Button>
                {channel &&
                    <Button className="mt-3" variant="secondary"
                        onClick={() => {
                            document.body.click();
                            dispatch(showModal('CONFIRM_MODAL', { dialogClassName: 'exist-relations', onConfirmClick: onDeleteClick, closeButton: false, confirmVariant: "danger", confirmText: "Delete", content: deleteConfirmContent() }));
                        }}>
                        Delete
                </Button>}
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" placement="right" overlay={popover} rootClose={true}>
            {trigger}
        </OverlayTrigger>
    )
}

export default AddChannel
